import { HttpErrorResponse } from '@angular/common/http';

/**
 * Pulls a readable message out of a failed upload request. The backend answers
 * validation failures (e.g. a video with the wrong codec) with a 400 whose body
 * is either a plain string or `{ message }`.
 *
 * @param err - The error the upload observable emitted.
 * @param fallback - Shown when the response carries no message of its own.
 */
export function getUploadErrorMessage(err: unknown, fallback: string): string {
  const body = err instanceof HttpErrorResponse ? err.error : undefined;

  if (typeof body === 'string' && body.trim() !== '') {
    return body;
  }
  if (typeof body?.message === 'string' && body.message.trim() !== '') {
    return body.message;
  }
  return fallback;
}
